import { DefaultProductOptions } from '../analytics-context-types';
import { getDGModalTag, getPODProductTag } from './utils';

/**
 * Gets the modal and product tag to track when user opens the email splash
 *
 * @param options attributes to be included in product tag and modal event tag
 * @returns
 */
export const getViewEmailSplashTag = (options: DefaultProductOptions) => {
  const modalEvent = [
    {
      eventInfo: {
        eventName: 'view animation',
        eventAction: 'view eCard',
      },
    },
  ];

  const { product } = getPODProductTag(options.productName, options.productID, 'eCards', options.productQuantity);

  const { modal, user } = getDGModalTag('Hooray', modalEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};

/**
 * Gets the modal and product tag to track when user hit the email splash
 *
 * @param options attributes to be included in product tag and modal event tag
 * @returns
 */
export const getKeepShoppingTag = (options: DefaultProductOptions) => {
  const modalEvent = [
    {
      eventInfo: {
        eventName: 'keep shopping',
        eventAction: 'keep shopping',
      },
    },
  ];

  const { product } = getPODProductTag(options.productName, options.productID, 'eCards', options.productQuantity);

  const { modal, user } = getDGModalTag('Hooray', modalEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
